import { render, staticRenderFns } from "./shareRegister.vue?vue&type=template&id=488b7a86&"
import script from "./shareRegister.vue?vue&type=script&lang=js&"
export * from "./shareRegister.vue?vue&type=script&lang=js&"
import style0 from "./shareRegister.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports